import React, { useState } from "react";
import {
  Button,
  InfoText,
  SmartTooltip,
  PageHeader,
  PageTitle,
  InfoWrapper,
  InfoCardNewAdv,
  TableAdv,
  FormFieldSet,
  Modal,
  Drawer,
  StatusTags,
} from "../../../../../../components";
import {
  dateFormator,
  keyToTitle,
  mapTableRows,
} from "../../../../../../utils";
import EditDeduction from "./Modals/EditDeduction";
import DeductionReceivePayment from "./Modals/DeductionReceivePayment";

const DeductionDetails = ({ data, onBack }) => {
  const [editModal, setEditModal] = useState(false);
  const [receivePaymentModal, setReceivePaymentModal] = useState(false);
  const deductionData = {
    deductionId: 101,
    deductionName: "Pranathi Penmetcha Required Payroll",
    deductionType: "Legal",
    payDate: "2025-01-01",
    invoice: { invoiceNumber: "INV-56456" },
    attachment: [
      new File(["dummy content"], "Document1.pdf", {
        type: "application/pdf",
      }),
    ],
    deductionAmount: "4800",
    paymentType: "Installment Plan",
    startDate: "01/01/2025",
    endDate: "01/31/2025",
    noOfInstallments: 6,
    taxDeduction: "Pre Tax Deduction",
    deductionMode: "",
    comment: "",
    status: "pending",
  };
  const summary = {
    totalReceivable: 34000,
    totalReceived: 14000,
    balanceLeft: 20000,
  };
  const [scheduleData, setScheduleData] = useState([
    {
      id: 1,
      schedule: "Schedule 1",
      payCycle: "01/01/2025 - 01/31/2025",
      amountReceivable: 7000,
      receivedAmount: 7000,
      comments: "",
    },
    {
      id: 2,
      schedule: "Schedule 2",
      payCycle: "01/01/2025 - 01/31/2025",
      amountReceivable: 7000,
      receivedAmount: 7000,
      comments: "",
    },
    {
      id: 3,
      schedule: "Schedule 3",
      payCycle: "",
      amountReceivable: 7000,
      receivedAmount: "",
      comments: "",
    },
  ]);
  const handleDeleteSchedule = (row) => {
    setScheduleData((prev) => prev?.filter((item) => item?.id !== row?.id));
  };

  const scheduleColumns = [
    {
      key: "schedule",
      label: "Schedule",
      render: (row) => (
        <SmartTooltip
          description={row?.schedule}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row.schedule}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "payCycle",
      label: "Pay Cycle",
      render: (row) => (
        <FormFieldSet
          type="select"
          noTitle
          value={row?.payCycle === "-" ? "" : row?.payCycle}
          options={[
            { label: "Select Pay Cycle", value: "" },
            {
              label: "01/01/2025 - 01/31/2025",
              value: "01/01/2025 - 01/31/2025",
            },
            {
              label: "02/01/2025 - 02/28/2025",
              value: "02/01/2025 - 02/28/2025",
            },
          ]}
          onChange={(value) => handleScheduleChange("payCycle", row, value)}
        />
      ),
    },
    {
      key: "amountReceivable",
      label: "Amount Receivable",
      render: (row) => (
        <FormFieldSet
          type="text"
          noTitle
          placeholder="Amount Receivable"
          value={row?.amountReceivable === "-" ? "" : row?.amountReceivable}
          onChange={(value) =>
            handleScheduleChange("amountReceivable", row, value)
          }
        />
      ),
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
      render: (row) => (
        <FormFieldSet
          type="text"
          noTitle
          placeholder="Received Amount"
          value={row?.receivedAmount === "-" ? "" : row?.receivedAmount}
          onChange={(value) =>
            handleScheduleChange("receivedAmount", row, value)
          }
        />
      ),
    },
    {
      key: "comments",
      label: "Comments",
      render: (row) => (
        <SmartTooltip
          description={row?.comments}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <FormFieldSet
            type="text"
            placeholder="Add Comment.."
            noTitle
            value={row?.comments === "-" ? "" : row?.comments}
            onChange={(value) => handleScheduleChange("comments", row, value)}
          />
        </SmartTooltip>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex">
          <SmartTooltip
            description={"Edit"}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <Button
              type="icon"
              icon="edit_square"
              size="sm"
              variant="text"
              color="black"
            />
          </SmartTooltip>
          <SmartTooltip
            description={"Delete"}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <Button
              type="icon"
              icon="delete"
              size="sm"
              variant="text"
              color="black"
              onClick={() => handleDeleteSchedule(row)}
            />
          </SmartTooltip>
        </div>
      ),
    },
  ];

  const mappedScheduleRows = mapTableRows(scheduleData, scheduleColumns);

  const handleScheduleChange = (field, row, value) => {
    setScheduleData((prev) =>
      prev?.map((item) =>
        item?.id === row?.id ? { ...item, [field]: value } : item,
      ),
    );
  };
  const getStatusConfig = (status) => {
    switch (status) {
      case "approved":
        return { tag: "approved", color: "success" };

      case "rejected":
        return { tag: "rejected", color: "danger" };

      case "pending":
      default:
        return { tag: "pending", color: "primary" };
    }
  };
  const statusConfig = getStatusConfig(deductionData?.status);
  console.log(statusConfig);
  return (
    <div>
      {/* Back Button */}
      <Button
        color="black"
        icon={"arrow_left_alt"}
        variant="text"
        title={`${data?.name} Details`}
        onClick={onBack}
        className="pl-1! pt-5 bg-transparent!"
        size="lg"
      />

      {/* General Details */}
      <div className="inner-section px-3 py-3 bg-gray-50! rounded-lg">
        <PageHeader
          Section={
            <div className="flex justify-start gap-1">
              <PageTitle title={"Deduction Information"} tag="h6" />
              <StatusTags
                tag={statusConfig?.tag}
                className={`bg-${statusConfig?.color}-50 text-${statusConfig?.color}`}
              />
            </div>
          }
          RightSection={
            <div className="flex gap-3 items-center">
              <Button
                title={"Edit"}
                icon={"edit_square"}
                size="sm"
                onClick={() => setEditModal(!editModal)}
              />
            </div>
          }
        />

        <div className="grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 mt-3">
          {Object.entries({
            deductionName: deductionData.deductionName,
            deductionType: deductionData.deductionType,
            payDate: deductionData.payDate,
            retailInvoiceNumber: deductionData.invoice?.invoiceNumber,
            attachment: deductionData.attachment,
            deductionAmount: `$${deductionData.deductionAmount}`,
            paymentType: deductionData.paymentType,
            startCycle: ` ${deductionData.startDate} - ${deductionData?.endDate}`,
            noOfInstallments: deductionData.noOfInstallments,
            taxDeduction: deductionData.taxDeduction,
            modeOfDeduction: deductionData.deductionMode,
            comment: deductionData.comment,
          }).map(([key, value]) => {
            const isDate =
              typeof value === "string" && value.match(/^\d{4}-\d{2}-\d{2}/);

            const isAttachment = key === "attachment";

            return (
              <InfoText
                key={key}
                size="sm"
                title={keyToTitle(key)}
                value={
                  isAttachment && value ? (
                    <div className="flex items-center justify-start w-full">
                      <span className="text-gray-800">{value[0]?.name}</span>
                      <Button
                        type="icon"
                        icon={"visibility"}
                        variant="text"
                        color="black"
                        onClick={() => {
                          const url = URL.createObjectURL(value[0]);
                          window.open(url);
                        }}
                      />
                    </div>
                  ) : isDate ? (
                    dateFormator(value, "short")
                  ) : (
                    value || "-"
                  )
                }
              />
            );
          })}
        </div>
      </div>

      {/* Summary Cards */}
      <div className="inner-section px-3 py-3 rounded-lg mt-5!">
        <PageHeader
          Section={
            <div className="flex justify-start">
              <PageTitle title={"Payment Schedule"} tag="h6" />
            </div>
          }
        />
        <div className="mt-5 border rounded-md border-gray-200 px-3 py-3 bg-gray-50">
          <PageTitle title={"Schedule Summary"} tag="p" className="pb-5!" />
          <InfoWrapper
            className={"min-w-[280px]! max-w-[300px]!"}
            wrapperClassName={"gap-8!"}
          >
            <InfoCardNewAdv
              title="Total Receivable"
              value={summary?.totalReceivable}
              layout="option12"
              prefix={"$"}
              bgConfig={{
                className: "bg-warning-50! rounded-lg! border-warning!",
              }}
              prefixConfig={{ className: "text-black!" }}
              valueConfig={{ className: "text-black!", decimals: 2 }}
              titleConfig={{ className: "text-black! font-bold!" }}
            />
            <InfoCardNewAdv
              title="Total Received"
              value={summary?.totalReceived}
              layout="option12"
              prefix={"$"}
              bgConfig={{
                className: "bg-success-50! rounded-lg! border-success!",
              }}
              prefixConfig={{ className: "text-black!" }}
              titleConfig={{ className: "text-black! font-bold!" }}
              valueConfig={{ className: "text-black!", decimals: 2 }}
            />
            <InfoCardNewAdv
              title="Balance Left"
              value={summary?.balanceLeft}
              layout="option12"
              prefix={"$"}
              bgConfig={{
                className: "bg-danger-50! rounded-lg! border-danger!",
              }}
              prefixConfig={{ className: "text-black!" }}
              titleConfig={{ className: "text-black! font-bold!" }}
              valueConfig={{ className: "text-black!", decimals: 2 }}
            />
          </InfoWrapper>
        </div>
      </div>
      <TableAdv
        tableId={"employee_payments_deductions_deductiondetails"}
        showSlNo
        columns={scheduleColumns}
        rows={mappedScheduleRows}
        toolbarRight={{
          search: true,
          add: [
            {
              component: (
                <div className="flex items-center gap-2">
                  <Button
                    title={"Receive Payment"}
                    variant="outlined"
                    onClick={() => setReceivePaymentModal(true)}
                  />
                  <Button title={"Add Schedule"} icon={"Add"} />
                </div>
              ),
            },
          ],
        }}
      />
      <Modal
        isOpen={editModal}
        onClose={() => setEditModal(false)}
        title="Edit Deduction Information"
        titleColor={"primary"}
        width="max-w-7xl"
      >
        <EditDeduction onClose={() => setEditModal(false)} />
      </Modal>
      <Drawer
        isOpen={receivePaymentModal}
        title={"Receive Payment"}
        onClose={() => setReceivePaymentModal(false)}
        width="w-[50%]"
        titleColor={"primary"}
      >
        <DeductionReceivePayment
          onClose={() => setReceivePaymentModal(false)}
        />
      </Drawer>
    </div>
  );
};

export default DeductionDetails;
